import { TableRow } from '@contentful/rich-text-types'
import { ClassNames, css } from '@emotion/core'
import React from 'react'
import Modal from 'react-modal'

import { breakpoints, emptySpaceWidthBreakPoint } from '../../constants/breakPoints'
import ContentfulTable from './ContentfulTable'

interface ContentfulTablePopupProps {
  content: TableRow[]
  preventOnClickHandler?: boolean
  showModal: boolean
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>
}

const ContentfulTablePopup: React.FunctionComponent<ContentfulTablePopupProps> = ({
  content,
  preventOnClickHandler,
  showModal,
  setShowModal,
}) => {
  return (
    <React.Fragment>
      <ClassNames>
        {(emotion) => {
          const overlayStyle = emotion.css`
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.65);
            position: fixed;
            top: 0;
            left: 0;
            z-index: 40;
          `
          const modalStyle = emotion.css`
            overflow: auto;
            position: fixed;
            width: 100%;
            box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
            outline: none;
            margin: 0px auto;
            border-radius: 0.5rem;
            box-sizing: border-box;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            max-width: 1136px;
            max-height: 90vh;

            @media screen and (max-width: ${emptySpaceWidthBreakPoint}px) {
              max-width: calc(100% - 4rem);
            }

            @media screen and (max-width: ${breakpoints.medium}px) {
              max-width: calc(100% - 3rem);
            }
          `

          return (
            <Modal
              isOpen={showModal}
              className={modalStyle}
              overlayClassName={overlayStyle}
              ariaHideApp={false}
              onRequestClose={() => {
                document.body.style.overflow = 'auto'
                setShowModal(false)
              }}
            >
              <ContentfulTable
                content={content}
                cssStyles={contentfulTableStyle}
                preventOnClickHandler={preventOnClickHandler}
              />
            </Modal>
          )
        }}
      </ClassNames>
    </React.Fragment>
  )
}

export default ContentfulTablePopup

const contentfulTableStyle = css`
  margin: 0 auto;

  table {
    width: auto;
  }

  th,
  td {
    max-width: 125px;
  }
`
